import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  Box,
  Button,
  Flex,
  Select,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { Space, Table } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { useAuth } from "../../store/auth/reducer";
import AddSubAdminsDrawer from "../drawer/AddSubAdminsDrawer";
import SubAdminDelete from "../modals/SubAdminDelete";
import { RiDeleteBin6Line, RiEditLine } from "react-icons/ri";

const SettingsTable: React.FC = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [targetData, setTargetData] = useState<any>();
  const [datas, setDatas] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  // console.log("Data", datas);

  const getData = () => {
    // Fetch data from API
    setLoading(true);
    axios({
      method: "get",
      url: `${process.env.REACT_APP_BASE_URL}/admin/subadmin`,
    })
      .then((response) => {
        // console.log("Product Details", response.data);
        setLoading(false);
        setDatas(
          response.data.data.map((val: any, i: number) => {
            return {
              key: i + 1,
              firstName: val.firstName || "-",
              lastName: val.lastName || "-",
              email: val.email || "-",
              password: val.password || "-",
              phoneNumber: val.phoneNumber || "-",
              _id: val._id,
              permits: val.permits,
              permission: val.permits?.map((val: any) => <p>{val.resource}</p>),
              value: val,
            };
          })
        );
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  const updates = (value: any) => {
    setTargetData(value);
    onViewOpen();
  };

  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const deletes = (value: any) => {
    setTargetData(value);
    onDeleteOpen();
  };

  const data = [
    {
      key: "1",
      name: "-",
      username: "-",
      email: "-",
      password: "-",
      confirmPassword: "-",
    },
  ];

  const columns = [
    {
      title: "Sr.No",
      dataIndex: "key",
      width: 100,
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      // width: 200,
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      // width: 200,
    },
    {
      title: "Email",
      dataIndex: "email",
      // width: 200,
    },
    {
      title: "Password",
      dataIndex: "password",
      width: 200,
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      // width: 200,
    },
    {
      title: "Permission",
      dataIndex: "permission",
      // width: 200,
    },
    {
      title: "Action",
      key: "value",
      width: 150,
      render: (record: any) => (
        <Space size="middle">
          <RiEditLine
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
            onClick={() => {
              updates(record);
            }}
          />
          <RiDeleteBin6Line
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
            onClick={() => {
              deletes(record);
            }}
          />
        </Space>
      ),
    },
  ];

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh ",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          {/* <Box>
            <Text fontSize="16px" fontWeight="500" mb={2}>
              Currency
            </Text>
            <Select
              placeholder="£"
              w="100%"
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              size="lg"
            >
              <option value="gbp">£ GBP</option>
              <option value="usd">$ USD</option>
              <option value="eur">€ EUR</option>
            </Select>
          </Box> */}

          <Box>
            <Flex justifyContent="space-between" alignItems="center" mb={4}>
              <Text fontSize="20px" fontWeight="500">
                Sub-admin
              </Text>
              <Button
                colorScheme="red"
                size="md"
                onClick={() => {
                  onOpen();
                }}
              >
                Add sub-admin
              </Button>
            </Flex>

            <Table
              rowSelection={rowSelection}
              columns={columns}
              dataSource={datas}
              loading={loading}
              scroll={{ x: "max-content" }}
              size="middle"
              pagination={{
                position: ["bottomRight"],
                pageSize: 9,
              }}
              style={{
                backgroundColor: "white",
                borderRadius: 6,
              }}
              rowClassName={(record: any) => record.color}
            />
          </Box>
        </div>
      </div>
      {isOpen && (
        <AddSubAdminsDrawer isOpen onClose={onClose} getData={getData} />
      )}
      {isViewOpen && (
        <AddSubAdminsDrawer
          isOpen={isViewOpen}
          onClose={onViewClose}
          getData={getData}
          editData={targetData}
        />
      )}
      {isDeleteOpen && targetData && (
        <SubAdminDelete
          subadmin={targetData}
          isOpen={isDeleteOpen}
          onClose={onDeleteClose}
          getData={getData}
        />
      )}
    </>
  );
};

export default SettingsTable;
